// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { processChainKeys } from '../query-keys';
import { useAuthStore } from '@/stores/auth-store';
import {
  getProcessChainTreeContract,
  getProcessChainContract,
  listProcessChainsContract,
  type GetProcessChainTreeResponse,
  type GetProcessChainResponse,
  type ListProcessChainsResponse
} from '@bliks-io/contracts';

// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated

/** Fetches the hierarchical tree of all process chains grouped by category. */
export function useProcessChainTree() {
  const { token } = useAuthStore();

  return useQuery({
    queryKey: processChainKeys.tree(),
    queryFn: async ({ signal }): Promise<GetProcessChainTreeResponse> => {
      const { data } = await apiClient.get<GetProcessChainTreeResponse>(
        getProcessChainTreeContract.path,
        { signal }
      );
      return data;
    },
    enabled: !!token,
    staleTime: 5 * 60 * 1000
  });
}

/** Fetches a single process chain with populated process data. */
export function useProcessChain(chainId: string) {
  const { token } = useAuthStore();

  return useQuery({
    queryKey: processChainKeys.detail(chainId),
    queryFn: async ({ signal }): Promise<GetProcessChainResponse['processChain']> => {
      const { data } = await apiClient.get<GetProcessChainResponse>(
        getProcessChainContract.path.replace(':id', chainId),
        { signal }
      );
      return data.processChain;
    },
    enabled: !!token && !!chainId,
    staleTime: 5 * 60 * 1000
  });
}

/** Fetches a list of process chains with optional filters. */
export function useProcessChainsList(filters?: {
  category?: string;
  parentChainId?: string | null;
}) {
  const { token } = useAuthStore();

  return useQuery({
    queryKey: processChainKeys.list(filters as Record<string, unknown> | undefined),
    queryFn: async ({ signal }): Promise<ListProcessChainsResponse['processChains']> => {
      const params = new URLSearchParams();
      if (filters?.category) params.set('category', filters.category);
      if (filters?.parentChainId) params.set('parentChainId', filters.parentChainId);
      const qs = params.toString();
      const { data } = await apiClient.get<ListProcessChainsResponse>(
        `${listProcessChainsContract.path}${qs ? `?${qs}` : ''}`,
        { signal }
      );
      return data.processChains;
    },
    enabled: !!token,
    staleTime: 5 * 60 * 1000
  });
}
